import React from 'react';
import { Input } from '@rocketseat/unform';
import { colors } from 'src/styles/index';
import styled from 'styled-components';
import { InputStyleMixin } from 'src/components/Input';
import { getBrandingColor, colorTypes } from 'src/branding';
import { Label } from './Layout';
import { HtmlLabel } from './Input';

const InputWrapper = styled.span`
  position: relative;
  display: block;

  /*error messages*/
  input + span {
    margin-bottom: 8px;
    display: block;
  }
`;

const StyledInput = styled.input`
  ${InputStyleMixin}
`;

export const LabeledInput = ({ name, label, ...props }) => (
  <HtmlLabel grow>
    {label && (
      <Label
        color={getBrandingColor(colorTypes.fontNormal)}
        marginLeft="4px"
        marginTop="6px"
        marginBottom="-2px"
      >
        {label}
      </Label>
    )}
    <InputWrapper>
      <StyledInput as={Input} name={name} {...props} tabIndex="1" />
    </InputWrapper>
  </HtmlLabel>
);
